import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
// services
import { MessageService } from '../../services/message.service';
import { MasterService } from '../../services/master.service';
import { StoreService } from '../../services/store.service';
import * as words from '../../services/language'
import { Sale } from 'src/app/models/sale.model';

@Component({
    selector: 'sale-recap',
    templateUrl: './sale-recap.component.html',
    styleUrls: ['./sale-recap.component.scss'],
    standalone: false
})
export class SaleRecapComponent implements OnInit, OnChanges {

    // The vehicle whose gps devices will be listed.
    @Input() saleId: number = 0
    
    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // Word replacements for each language.
    @Input() words: Object = words.language

    // A list of gps devices for the given vehicle.
    protected sale: Sale;

    /** The sale fees grouped by category. */
    protected fees: Object | null = null
    
    // Indicates whether the data is currently loading.
    protected loading: boolean = false

    get feeKeys () {
        if (!this.fees) {
            return []
        }

        return Object.keys(this.fees)
    }

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        this.reset()
        this.fetch()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        if (changes.saleId) {
            this.reset()
            this.fetch()
        }
    }

    /**
     * 
     * @param e 
     */
    public cancel = (e: Event): void => {
        e.stopPropagation()
        e.preventDefault()

        this.reset()
    }

    /*
    * Reset the sale
    */
    private reset = (): void => {
        this.sale = null
    }

    /**
     * 
     */
    private fetch() {
        if (this.loading) {
            return
        }

        if (!this.saleId || (this.saleId <= 0)) {
            return
        }

        this.sale = null
        this.fees = null
        this.loading = true

        this.master.get(`sales/${this.saleId}`, (res) => {
            this.loading = false

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }          
            
            this.assemble(res.data.sale)
        })
    }

    /**
     * 
     * @param sale 
     */
    private assemble = (sale: Sale) => {
        if (!sale || !sale.id) {
            return
        }

        this.sale = sale

        if (!sale.fees) {
            return
        }

        this.fees = {}

        for (const tax of sale.fees.taxes) {
            if (!this.fees[tax.category]) {
                this.fees[tax.category] = 0
            }

            this.fees[tax.category] += tax.amount
        }

        for (const fee of sale.fees.fees) {
            if (!this.fees[`${fee.category} Fees`]) {
                this.fees[`${fee.category} Fees`] = 0
            }

            this.fees[`${fee.category} Fees`] += fee.amount
        }
    }
}
